import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectUser } from 'oidc/user.selectors';
import {
  canChangeSubmissionPause,
  useReadOnly,
} from 'oidc/userRoles';

export const useSubmissionPauseToggleAccess = (isSubmissionPaused: boolean) => {
  const { t } = useTranslation();
  const { userInfo } = useSelector(selectUser);
  const { readOnly, showTooltip: showReadOnlyTooltip } = useReadOnly();
  const roles = userInfo?.roles ?? [];

  const hasRolePermission = canChangeSubmissionPause(roles, isSubmissionPaused);
  const canToggle = !readOnly && hasRolePermission;

  const tooltipContent = readOnly && showReadOnlyTooltip
    ? t('global.readOnlyTooltip')
    : !hasRolePermission
      ? isSubmissionPaused
        ? t('candidate.submissionPaused.turnOffPermissionDisabled')
        : t('candidate.submissionPaused.permissionDisabled')
      : undefined;

  return {
    canToggle,
    tooltipContent,
    showPermissionTooltip: !!tooltipContent && !canToggle,
  };
};
